<template>
    <card>
       <template slot="header">
          <h3 class="card-title">Responsibility Details</h3>
       </template>
       <div class="row">
         <div class="col-md-10">  
            <nav class="row">
             <ol class="breadcrumb arr-right bg-breadcrum">
                <li class="breadcrumb-item">
                   <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                </li>
                <li class="breadcrumb-item">
                   <router-link to="/hr/responsibilityform">Responsibilities Record</router-link>
                </li>
                <li class="breadcrumb-item active">Responsibility Details</li>
             </ol>
          </nav>
         </div>  
          <!-- <div class="col-md-2">
                <button @click="print" class="float-right"><i class="fa fa-print"></i>Print Preview</button> 
           </div>   -->
       </div>
       <hr style="margin-top:-10px"/>
       <div class="responsibility-form-body">
          <img class="logo-print" width="190" height="110" src="/static/img/blueprintlogo.png" alt="..."/>
          <br/><br/>
          <div class="col-md-12 border-form">
             <center>
                <h3>EMPLOYEE RESPONSIBILITY FORM</h3>
             </center>
          </div>
          <div class="division-gatter"></div>
          <div class="col-md-12 border-form">
             <div class="row">
                <div class="col-md-6">
                   <p class="top-gatter"><b>Employee Name :</b> {{item.first_name  | capitalize }} , {{item.last_name  | capitalize}}
                       
                   </p>
                   <p class="top-gatter"><b>Department:</b> {{item.department_name | capitalize}}</p>
                </div>
                <div class="col-md-6">
                   <p class="top-gatter"><b>Employee Number :</b> {{item.emp_id}}</p>
                   <p class="top-gatter"><b>Position :</b>  {{item.position_name | capitalize}}</p>
                </div>
             </div>
          </div>
          <div class="col-md-12">   
                <br/> <p class="top-gatter">I hereby acknowledge that I have received the following company property:</p> <br/>
          </div>
          <div class="col-md-12 border-form">
             <table width="100%">
                <thead>
                   <tr>
                      <th>Name of Item</th>
                      <th>Description / Serial Number</th>
                      <th>Quantity</th>
                      <th>Date Received</th>
                   </tr>
                </thead>
                <tbody>
                   <tr v-for="resp,i in item.res">
                      <td>{{i+1}}. &nbsp;{{resp.name}}</td>
                      <td>{{resp.description}}</td>
                      <td>{{resp.quantity}}</td>
                      <td>{{resp.received}}</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <br/>
          <div class="col-md-12">
             <p class="top-gatter">I aggree to keep the property in working condition, and to notify management should the property 
                malfunction in any way, or should the property be lost or stolen. Further, I agree to return this property
                at the end of my employment.When I no longer need one or more of the items, I will return it/them
                immediately to my immediate supervisor.
             </p>
          </div>
          <br/><br/><br/><br/><br/>
          <!-- SIGNATURE -->
          <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-5"></div>
              <div class="col-md-3">
                <img class="get_image"  :src="item.signature" alt="..."/>
                 <div class="line-divider"></div>
                 <div class="noted-date">Employee Signature</div>
                 <div class="div-spliter"></div>
              </div>
           </div>
          <!-- END SIGNATURE -->
        
          <p>HR FORM NO. 0003</p>

       </div>
    </card>
 </template>
     <script src="https://cdn.jsdelivr.net/npm/signature_pad@2.3.2/dist/signature_pad.min.js"></script>
    <script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
    
export default {
   components: {
      Card
   },
   data() {
      return {
         item: {}
      }
   },
   mounted: function() {
      this.fetchItem();
   },
   methods: {
      fetchItem() {
         axios.get('api/responsibility/get/' + this.$route.params.id)
            .then(resp => {
               this.item = resp.data;

            })
            .catch(error => {
               console.log(error)
            });
      },
      print() {
         window.print();
      },
      getDate(date) {
         return moment(date).format('MMM DD YYYY');
      },
      undo() {
         this.$refs.signaturePadOne.undoSignature();
      },
      save() {
         const {
            isEmpty,
            data
         } = this.$refs.signaturePadOne.saveSignature();
         //const { isEmptyTwo, b } = this.$refs.signaturePadTwo.saveSignature();

         // if(isEmptyOne){
         //    alert('empty');
         // }else{
         //     alert(a);
         // }

         console.log('response one =>', isEmpty);
         console.log('signature =>', a);
         //console.log('response two =>',a);
      }
   },


}
    </script>
    <style>
    .bg-breadcrum{
          background:#fff;
    }
    .border-form{
          border: 1px solid #666;
    }
    .division-gatter{
       height: 7px;
    }
    .top-gatter{
        margin-top:8px;
        margin-bottom: 10px;
    }

    .line-divider{
        background: #666;
        height: 1px;
        width: 100%;
    }
    .noted-date{
        margin-left: 34%;
    }
    .responsibility-form-body{
        width: 75%;
        margin: auto;
    }
    .signature-control{
        position: absolute;
        width: 190px;
        height: 90px;
        margin-top:-90px;
        margin-left:31%;  
    }
    .note-sign{
        position: absolute;
        margin-top:150px;
        color:red;
        margin-left:15%;
        font-size: 14px;

    }

    .divider-signature{
        height: 220px;
    }

    .date-margin{
        margin-left:24%;
    }
   

    .get_image{
        position: absolute;
        width: 95px;
        height: 95px;
        margin-top:-73px;
        margin-left:35%;  
    }

    </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-responsibility-form/todo-view-responsibility.vue